module.exports = __webpack_public_path__ + "img/symbol_5.cbb0a080.png";